import { render, staticRenderFns } from "./BulkSendModal.vue?vue&type=template&id=0b9a7958&scoped=true"
import script from "./BulkSendModal.vue?vue&type=script&lang=js"
export * from "./BulkSendModal.vue?vue&type=script&lang=js"
import style0 from "./BulkSendModal.vue?vue&type=style&index=0&id=0b9a7958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a7958",
  null
  
)

export default component.exports